export default async function (dispatch, commit, axios, jsonURL) {
  let workspace = await axios.get(jsonURL)
  workspace = workspace.data

  async function testNode (node, button) {
    if (node.output != null && Array.isArray(node.output.json_response)) {
      let conditions = node.conditions.split(/&&|\|\|/g)
      let message = conditions.map(function (element) {
        let conds = element.match(/(#[a-zA-Z0-9_.áéíóúñ-]*)|(@[^)]*\))|(@[a-zA-Z0-9_:.áéíóúñ-]*)/g)
        if (conds !== null) {
          let question = conds.map(function (cond) {
            if (cond[0] === '#') {
              return workspace.intents.filter((value) => value.intent === cond.slice(1))[0].examples[0].text
            }
            cond = cond.replace(/\(|\)/g, '')
            let entity = cond.slice(1).split(':')
            if (entity.length === 1) {
              return workspace.entities.filter((value) => value.entity === entity[0])[0].values[0].synonyms[0]
            } else {
              return workspace.entities.filter((value) => value.entity === entity[0])[0].values.filter((value) => value.value === entity[1])[0].synonyms[0]
            }
          }).join(' ')
          return question
        }
        return ''
      }).join(' ')
      await dispatch('sendMessage', {message})
      if (typeof button === 'string') {
        await dispatch('sendMessage', {message: button})
      }
    }
  }

  async function checkButtons (node) {
    if (node.output != null && Array.isArray(node.output.buttons)) {
      for (let button of node.output.buttons) {
        let btnMessage = null
        if (!Array.isArray(button) && typeof button === 'object' && button !== null) {
          btnMessage = button.message
        } else if (typeof button === 'string') {
          btnMessage = button
        }
        await testNode(node, btnMessage)
      }
    } else {
      await testNode(node)
    }
  }

  for (let node of workspace.dialog_nodes) {
    if (node.parent === null) {
      try {
        await checkButtons(node)
      } catch (err) {
        // do nothing
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/test/testWorkspace.js